import React from 'react';
import { PlusIcon, TagIcon, CalendarIcon, TrashIcon, PencilIcon, CheckIcon } from 'lucide-react';
// Sample promotions data
const promotions = [{
  id: 'PROMO001',
  name: 'Summer Sale',
  code: 'SUMMER25',
  discount: 25,
  type: 'percentage',
  startDate: '2023-06-01',
  endDate: '2023-08-31',
  status: 'active',
  usageLimit: 1000,
  usageCount: 342
}, {
  id: 'PROMO002',
  name: 'New Customer',
  code: 'WELCOME10',
  discount: 10,
  type: 'percentage',
  startDate: '2023-01-01',
  endDate: '2023-12-31',
  status: 'active',
  usageLimit: 5000,
  usageCount: 1245
}, {
  id: 'PROMO003',
  name: 'Free Shipping',
  code: 'FREESHIP',
  discount: 0,
  type: 'free_shipping',
  startDate: '2023-07-15',
  endDate: '2023-08-15',
  status: 'active',
  usageLimit: 500,
  usageCount: 89
}, {
  id: 'PROMO004',
  name: 'Flash Sale',
  code: 'FLASH50',
  discount: 50,
  type: 'percentage',
  startDate: '2023-09-01',
  endDate: '2023-09-03',
  status: 'scheduled',
  usageLimit: 200,
  usageCount: 0
}, {
  id: 'PROMO005',
  name: 'Black Friday',
  code: 'BF2023',
  discount: 30,
  type: 'percentage',
  startDate: '2023-11-24',
  endDate: '2023-11-27',
  status: 'scheduled',
  usageLimit: 2000,
  usageCount: 0
}];
export const Promotions: React.FC = () => {
  const getStatusClass = (status: string) => {
    switch (status) {
      case 'active':
        return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300';
      case 'scheduled':
        return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300';
      case 'expired':
        return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
      default:
        return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
    }
  };
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };
  return <div className="container mx-auto px-4 py-8" data-id="element-896">
      <div className="flex justify-between items-center mb-6" data-id="element-897">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-898">
          Promotions
        </h1>
        <button className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-md flex items-center" data-id="element-899">
          <PlusIcon size={18} className="mr-1" data-id="element-900" />
          Create Promotion
        </button>
      </div>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm overflow-hidden mb-8" data-id="element-901">
        <div className="p-6 border-b border-gray-200 dark:border-gray-700" data-id="element-902">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-903">
            Create New Discount Code
          </h2>
        </div>
        <div className="p-6" data-id="element-904">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-905">
            <div data-id="element-906">
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-907">
                Promotion Name
              </label>
              <input type="text" id="name" className="w-full border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-500" placeholder="e.g. Summer Sale" data-id="element-908" />
            </div>
            <div data-id="element-909">
              <label htmlFor="code" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-910">
                Discount Code
              </label>
              <input type="text" id="code" className="w-full border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-500" placeholder="e.g. SUMMER25" data-id="element-911" />
            </div>
            <div data-id="element-912">
              <label htmlFor="type" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-913">
                Discount Type
              </label>
              <select id="type" className="w-full border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-500" data-id="element-914">
                <option value="percentage" data-id="element-915">Percentage Discount</option>
                <option value="fixed" data-id="element-916">Fixed Amount Discount</option>
                <option value="free_shipping" data-id="element-917">Free Shipping</option>
              </select>
            </div>
            <div data-id="element-918">
              <label htmlFor="discount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-919">
                Discount Value
              </label>
              <div className="relative" data-id="element-920">
                <input type="number" id="discount" className="w-full border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-500" placeholder="25" data-id="element-921" />
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-922">
                  <span className="text-gray-500 dark:text-gray-400" data-id="element-923">%</span>
                </div>
              </div>
            </div>
            <div data-id="element-924">
              <label htmlFor="startDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-925">
                Start Date
              </label>
              <input type="date" id="startDate" className="w-full border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-500" data-id="element-926" />
            </div>
            <div data-id="element-927">
              <label htmlFor="endDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-928">
                End Date
              </label>
              <input type="date" id="endDate" className="w-full border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-500" data-id="element-929" />
            </div>
            <div data-id="element-930">
              <label htmlFor="usageLimit" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-931">
                Usage Limit
              </label>
              <input type="number" id="usageLimit" className="w-full border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-500" placeholder="1000" data-id="element-932" />
            </div>
            <div data-id="element-933">
              <label htmlFor="minPurchase" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-934">
                Minimum Purchase (Optional)
              </label>
              <div className="relative" data-id="element-935">
                <span className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-936">
                  <span className="text-gray-500 dark:text-gray-400" data-id="element-937">$</span>
                </span>
                <input type="number" id="minPurchase" className="w-full pl-8 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-yellow-500" placeholder="100" data-id="element-938" />
              </div>
            </div>
          </div>
          <div className="mt-6" data-id="element-939">
            <button className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-md" data-id="element-940">
              Create Promotion
            </button>
          </div>
        </div>
      </div>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm overflow-hidden" data-id="element-941">
        <div className="p-6 border-b border-gray-200 dark:border-gray-700" data-id="element-942">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-943">
            Active Promotions
          </h2>
        </div>
        <div className="overflow-x-auto" data-id="element-944">
          <table className="w-full" data-id="element-945">
            <thead className="bg-gray-50 dark:bg-gray-900" data-id="element-946">
              <tr data-id="element-947">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-948">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-949">
                  Code
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-950">
                  Discount
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-951">
                  Duration
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-952">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-953">
                  Usage
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider" data-id="element-954">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-gray-700" data-id="element-955">
              {promotions.map(promo => <tr key={promo.id} data-id="element-956">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-957">
                    <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-958">
                      {promo.name}
                    </div>
                    <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-959">
                      ID: {promo.id}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-960">
                    <span className="px-2 py-1 text-xs font-mono bg-gray-100 dark:bg-gray-700 rounded text-gray-800 dark:text-gray-200" data-id="element-961">
                      {promo.code}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white" data-id="element-962">
                    {promo.type === 'percentage' ? `${promo.discount}%` : promo.type === 'fixed' ? `$${promo.discount}` : 'Free Shipping'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-963">
                    <div className="flex items-center text-sm text-gray-500 dark:text-gray-400" data-id="element-964">
                      <CalendarIcon size={14} className="mr-1" data-id="element-965" />
                      <span data-id="element-966">
                        {formatDate(promo.startDate)} -{' '}
                        {formatDate(promo.endDate)}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-967">
                    <span className={`px-2 py-1 text-xs font-semibold rounded-full ${getStatusClass(promo.status)}`} data-id="element-968">
                      {promo.status.charAt(0).toUpperCase() + promo.status.slice(1)}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-969">
                    {promo.usageCount} / {promo.usageLimit}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm" data-id="element-970">
                    <div className="flex justify-end space-x-2" data-id="element-971">
                      <button className="p-1 text-yellow-600 dark:text-yellow-400 hover:text-yellow-800 dark:hover:text-yellow-300" data-id="element-972">
                        <PencilIcon size={18} data-id="element-973" />
                      </button>
                      <button className="p-1 text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300" data-id="element-974">
                        <TrashIcon size={18} data-id="element-975" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};